import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=06b2f0bc&scoped=true"
import script from "./MessageAttachment.vue?vue&type=script&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=06b2f0bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2f0bc",
  null
  
)

export default component.exports